export const menubarHeaderDesignToken = {
	padding: '0 1.5rem 0 1.5rem',
	background: '{primary.950}',
	border: {
		radius: '0',
		color: '{primary.900}',
	},
	item: {
		color: 'white',
		focus: {
			color: 'white',
			background: '{primary.700}',
		},
	},
	mobile: {
		button: {
			color: 'white',
			hover: {
				background: '{primary.700}',
				color: 'white',
			},
		},
	},
	submenu: {
		background: '{primary.900}',
	},
};
